import { render, staticRenderFns } from "./products.vue?vue&type=template&id=0f581ad0&scoped=true&"
var script = {}
import style0 from "./products.vue?vue&type=style&index=0&id=0f581ad0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f581ad0",
  null
  
)

export default component.exports